export const ALREADY_ENROLLED_CODE = 40002;
export const ALREADY_ENROLLED_REDIRECT_DELAY = 2000;

export const clearAlreadyEnrolledRedirect = (timerId) => {
  if (timerId) clearTimeout(timerId);
  return null;
};

export const scheduleAlreadyEnrolledRedirect = ({
  response,
  showMessage,
  redirect,
}) => {
  const courseInfo = response?.data;
  if (response?.code !== ALREADY_ENROLLED_CODE || !courseInfo?.id) {
    return null;
  }

  showMessage(response.message, ALREADY_ENROLLED_REDIRECT_DELAY);
  const timerId = setTimeout(() => {
    redirect(courseInfo);
  }, ALREADY_ENROLLED_REDIRECT_DELAY);

  return {
    courseInfo,
    timerId,
  };
};

export const jumpToExchangeCourse = ({
  isHXApp,
  courseInfo,
  openNativePage,
  router,
}) => {
  if (isHXApp) {
    openNativePage(
      "openPage",
      { courseId: courseInfo.id },
      { name: "myCourseDetail" }
    );
    return;
  }

  router.push({
    name: "myCourseDetail",
    params: { id: courseInfo.id },
  });
};
